import { Button } from '../Button/Button';
import React from 'react';
import { goBack } from 'react-router-redux';
import { connect } from 'react-redux';

const BackButton = ({ goBack }) => {
  return (
    <Button bsStyle="default" label="Back" handleClick={goBack} leftIcon="caret-left" />
  );
};

export default connect(
  null,
  {
    goBack: goBack,
  },
)(BackButton);
